/* unplugin-vue-components disabled */import { render } from "./PopupArea.vue?vue&type=template&id=9c38dd2e&ts=true"
import script from "./PopupArea.vue?vue&type=script&lang=ts"
export * from "./PopupArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__